const VoiceDictation = {
    mounted() {

        this.textarea = this.el.querySelector("textarea");
        this.trigger = this.el.querySelector("[data-dictation-trigger]");
        this.isListening = false;

        if (!this.textarea || !this.trigger) return;

        // Check browser support
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            this.trigger.style.display = "none";
            console.warn("Voice dictation not supported in this browser");
            return;
        }

        this.recognition = new SpeechRecognition();
        this.recognition.continuous = true; // Keep listening even after pauses
        this.recognition.interimResults = true; // Show results as they are being spoken
        this.recognition.lang = "en-US"; // Default to English, could be parameterized

        this.recognition.onstart = () => {
            this.isListening = true;
            this.trigger.classList.add("text-red-500", "animate-pulse"); // Visual feedback
            this.trigger.classList.remove("text-isx-ltgray");
        };

        this.recognition.onend = () => {
            this.isListening = false;
            this.trigger.classList.remove("text-red-500", "animate-pulse");
            this.trigger.classList.add("text-isx-ltgray");
        };

        this.recognition.onresult = (event) => {
            let finalTranscript = "";
            let interimTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; ++i) {
                if (event.results[i].isFinal) {
                    finalTranscript += event.results[i][0].transcript;
                } else {
                    interimTranscript += event.results[i][0].transcript;
                }
            }

            // Logic to append text. 
            // Note: This simple append approach might get tricky with cursor positions if the user edits while speaking.
            // For now, valid MVP is appending or inserting at cursor.

            if (finalTranscript) {
                this.insertText(finalTranscript + " "); // Add space after sentence
            }
        };

        this.recognition.onerror = (event) => {
            console.error("Speech recognition error", event.error);
            this.isListening = false;
            this.trigger.classList.remove("text-red-500", "animate-pulse");
        };

        this.trigger.addEventListener("click", (e) => {
            e.preventDefault();
            this.toggleDictation();
        });
    },

    toggleDictation() {
        if (this.isListening) {
            this.recognition.stop();
        } else {
            this.recognition.start();
        }
    },

    insertText(text) {
        if (!this.textarea) return;

        const start = this.textarea.selectionStart;
        const end = this.textarea.selectionEnd;
        const originalText = this.textarea.value;

        // Insert text at cursor position
        const newText = originalText.substring(0, start) + text + originalText.substring(end);

        this.textarea.value = newText;

        // Move cursor after inserted text
        this.textarea.selectionStart = this.textarea.selectionEnd = start + text.length;

        // Trigger input event for LiveView
        this.textarea.dispatchEvent(new Event('input', { bubbles: true }));
    }
};

export default VoiceDictation;
